// extracted by mini-css-extract-plugin
module.exports = {"bookAsideContainer":"styles_bookAsideContainer__gRumx","bookAsideStickyContainer":"styles_bookAsideStickyContainer__9Zdax"};